export const COLORS = {
  MAIN: "#c80f2e",
  PRIMARY: "#007bff",
  SECONDARY: "#0a4da0",
  GREY: "#DAE1E7",
  DARK_GREY: "#8997A1",
  DANGER: "rgb(203,88,88)",
  SUCCESS: "rgb(50, 146, 57)",
  FONT: "#fffeff",
  WARNING: "#ffc107",
  INFO: "#17a2b8",
  LIGHT: "#f8f9fa",
  DISABLED: "#d3d3d3", // Color para el fondo deshabilitado
  DISABLED_TEXT: "#a9a9a9", // Color de texto para el estado deshabilitado
  TEXT: "#ffffff", // Color de texto por defecto
  DARK: "#343a40",
  BLANCO: "#fffff",
  ROJO_CLARO: "#c86141",
  VIOLETA: "#b54aef",
  VERDE_CLARO: "rgb(50 146 57)",
  CELESTE_CLARO: "#78b1db",
  AMARILLO_PENDIENTE: "rgb(250 255 110)",
};
